(function () {
  'use strict';

  if (customElements.get('mg-variant-selects')) return;

  class MGHighVariantSelects extends HTMLElement {
    constructor() {
      super();
      this.abortController = null;
      this.addEventListener('change', this.onChange.bind(this));
    }

    connectedCallback() {
      this.hidePersonalizationOption();
    }

    get productInfo() {
      return this.closest('product-info') || document;
    }

    get form() {
      return document.getElementById('product-form-' + this.dataset.section);
    }

    hidePersonalizationOption() {
      var select = this.querySelector('select[name="options[Personalization]"]');
      var wrapper = select && select.closest('.product-form__input');
      if (wrapper) wrapper.classList.add('mgp-hidden-personalization-option');
    }

    selectedOptionValueIds() {
      return Array.from(this.querySelectorAll('select')).map(function (select) {
        var selected = select.options[select.selectedIndex];
        return selected && selected.dataset.optionValueId;
      }).filter(Boolean);
    }

    setBusy(busy) {
      var button = this.form && this.form.querySelector('[name="add"]');
      if (!button) return;
      if (busy) button.setAttribute('disabled', 'disabled');
      else button.removeAttribute('disabled');
    }

    onChange(event) {
      if (!event.target.matches('select')) return;
      var ids = this.selectedOptionValueIds();
      if (!ids.length) return;
      this.renderSelection(ids, event.target.id);
    }

    renderSelection(ids, focusId) {
      if (this.abortController) this.abortController.abort();
      this.abortController = new AbortController();
      this.setBusy(true);

      var separator = this.dataset.url.indexOf('?') === -1 ? '?' : '&';
      var requestUrl = this.dataset.url + separator + 'section_id=' + encodeURIComponent(this.dataset.section) + '&option_values=' + ids.map(encodeURIComponent).join(',');

      fetch(requestUrl, { signal: this.abortController.signal })
        .then(function (response) {
          if (!response.ok) throw new Error('Variant request failed: ' + response.status);
          return response.text();
        })
        .then(function (text) {
          var html = new DOMParser().parseFromString(text, 'text/html');
          var source = html.querySelector('mg-variant-selects[data-section="' + this.dataset.section + '"]');
          if (!source) throw new Error('Variant selector missing from section response');

          var variant = null;
          var variantNode = source.querySelector('[data-selected-variant]');
          try { variant = JSON.parse(variantNode ? variantNode.textContent : 'null'); }
          catch (error) { variant = null; }

          this.innerHTML = source.innerHTML;
          this.hidePersonalizationOption();
          this.updateVariant(variant, html);
          document.dispatchEvent(new CustomEvent('mg:variant-updated', { detail: { variant: variant } }));

          var coarsePointer = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
          if (focusId && !coarsePointer) {
            var focusTarget = document.getElementById(focusId);
            if (focusTarget) focusTarget.focus({ preventScroll: true });
          }
        }.bind(this))
        .catch(function (error) {
          if (error.name !== 'AbortError') {
            console.error(error);
            this.setBusy(false);
          }
        }.bind(this));
    }

    updateVariant(variant, html) {
      var section = this.dataset.section;
      var form = this.form;
      var idInput = form && form.querySelector('input[name="id"]');
      var button = form && form.querySelector('[name="add"]');
      var sourceButton = html.getElementById('ProductSubmitButton-' + section);

      if (idInput) {
        idInput.value = variant ? variant.id : '';
        idInput.removeAttribute('disabled');
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      ['price', 'Inventory', 'Sku'].forEach(function (prefix) {
        var destination = document.getElementById(prefix + '-' + section);
        var source = html.getElementById(prefix + '-' + section);
        if (destination && source) destination.innerHTML = source.innerHTML;
      });

      if (button) {
        var unavailable = !variant || (sourceButton && sourceButton.hasAttribute('disabled'));
        if (unavailable) button.setAttribute('disabled', 'disabled');
        else button.removeAttribute('disabled');
        var buttonText = button.querySelector('span');
        var sourceText = sourceButton && sourceButton.querySelector('span');
        if (buttonText && sourceText) buttonText.textContent = sourceText.textContent;
      }

      if (variant && variant.featured_media) {
        var gallery = document.querySelector('[id^="MediaGallery-' + section + '"]');
        if (gallery && gallery.setActiveMedia) gallery.setActiveMedia(section + '-' + variant.featured_media.id, true);
      }

      if (variant && this.dataset.updateUrl !== 'false') {
        window.history.replaceState({}, '', this.dataset.url + '?variant=' + variant.id);
      }

      if (typeof publish === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
        publish(PUB_SUB_EVENTS.variantChange, { data: { sectionId: section, html: html, variant: variant } });
      }
    }
  }

  customElements.define('mg-variant-selects', MGHighVariantSelects);
})();
